import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface UploadOnboardingRequest {
  file: File;
  name: string;
  token: string;
}

const uploadOnboarding = async ({
  file,
  token,
  name,
}: UploadOnboardingRequest): Promise<string> => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/upload`,
      { file: file, key: name },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default uploadOnboarding;
